<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <tabs-nav
          slot="tabs-nav"
          :links="navLinks"
        />
        <!-- <h3 class="is-3">
          {{ $t('message.title') }}
        </h3> -->
      </div>
    </div>
    
    <div class="columns is-centered">
      <div class="column">
        <p style="margin-left:1%">
          <dropdown
            v-model="zoningDistrict"
            :options="calculatorOptions.zoningDistrict"
            :placeholder="zoningDistrictPlaceholder"
            @change="reset()"
          />
        </p>
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column">
        <p style="margin-left:1%">
          <dropdown
            v-model="affordabilityLevel"
            :options="translatedOptions"
            :placeholder="affordabilityLevelPlaceholder"
            @change="reset()"
          />
        </p>
      </div>
      <!--Lang Switcher 
      <div class="column">
        <select
          v-model="selectedLanguage"
          @change="changeLanguage"
        >
          <option
            v-for="lang in supportedLanguages"
            :key="lang"
          >
            {{ lang }}
          </option>
        </select>
      </div> -->
    </div>
    <div class="columns">
      <div class="column">
        <p style="margin-left: 2%">
          {{ $t('message.allThatApply') }}
          <checkbox
            v-model="overlays"
            :options="translatedOverlays"
            :text-key="textKey"
            :value-key="valueKey"
          />
        </p>
        <!--
        <div 
          v-if="(zoningDistrict !== 'RM-1' && zoningDistrict !== 'CMX-1' && zoningDistrict !== 'CMX-2' && zoningDistrict !== 'CMX-2.5' )"
          class="column"
        > 
          <p style="margin-top:-3%; margin-left:1%">
            <checkbox
              v-models="sFHA"
              :options="calculatorOptions.sFHA"
              :text-key="textKey"
              :value-key="valueKey"
            />
          </p>
        </div>
        -->
        <div
          v-if="overlays.includes($t('message.overlay.fithDistrict'))"
          class="columns is-centered"
        >
          <div class="column">
            <p style="margin-left:5%">
              <label> {{ $t("message.springGardenS") }} </label>
              <select
                v-model="springGardenS"
                name="input-springGardenS"
                required
              > 
                <option
                  value=""
                  disabled
                  selected
                />
                <option value="Yes">
                  {{ $t("message.yes") }}
                </option>
                <option value="No">
                  {{ $t("message.no") }}
                </option>
              </select>
            </p>
          </div>
        </div>
        <div class="columns is-centered"> 
          <div class="column">
            <p style="margin-left: 1%">
              <textbox
                v-model="lotAreaSqFeet"
                name="input-lotAreaSqFeet"
                :placeholder="lotAreaSqftPlaceholder"
              />
            </p>
          </div>
        </div>
        <div 
          v-if="zoningDistrict === 'CMX-2.5'"
          class="columns is-centered"
        >
          <div class="column">
            <p style="margin-left:1%">
              <textbox
                v-model="buildingHeight"
                name="input-buildingHeight"
                :placeholder="buildingHeightPlaceholder"
              />
            </p>
          </div>
        </div>
        <div 
          v-if="(zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5')" 
          class="columns is-centered"
        >
          <div class="column">
            <p style="margin-left:1%">
              <textbox
                v-model="totalFarUnits"
                name="input-totalFarUnits"
                :placeholder="totalUnitsPlaceholder"
                type="number"
                min="0"
                max="100"
              />
            </p>
          </div>
        </div>
        <div 
          v-if="(zoningDistrict == 'RM-1' || zoningDistrict == 'CMX-1' || zoningDistrict == 'CMX-2' || zoningDistrict == 'CMX-2.5' )"
          class="column"
        > 
          <div class="columns is-centered">
            <div class="column">
              <p style="margin-left: 3%">
                {{ $t('message.numberOfDwellingUnits') }} 
              </p>
            </div>
            <div class="column">
              <div> 
                <p
                  class="line-indent"
                  style="margin-left: 0%"
                >
                  <b>{{ dwellingUnits }}</b>
                </p>
              </div>
            </div>
          </div>
          <div>
            <div
              v-if="affordabilityLevel === $t('message.affordability.lowIncome')"
              class="columns is-centered"
            >
              <div class="column">
                <p style="margin-left: 3%">
                  {{ $t("message.unitsEarnedLow") }}
                </p>
              </div>
              <div class="column">
                <p
                  style="margin-left: 0.35%"
                  class="line-indent"
                >
                  <!-- This appears to be the fix for the additional 1 added to   Dwelling Units
                 <b>{{ (springGardenS == "Yes") ? Math.floor((dwellingUnits)*0.5) : 0 }}</b> -->
                  <b>{{ (springGardenS === $t('message.no')) ? 0 : additionalLowUnitsEarned }}</b>
                </p>
              <!-- <p>
                <b>{{ additionalLowUnitsEarned }}</b>
              </p> -->
              </div>
            </div>
          </div>

          <div>
            <div
              v-if="affordabilityLevel === $t('message.affordability.moderateIncome')"
              class="columns is-centered"
            >
              <div class="column">
                <p style="margin-left: 3%">
                  {{ $t("message.unitsEarnedMod") }}
                </p>
              </div>
              <div class="column">
                <p
                  style="margin-left: 0.35%"
                  class="line-indent"
                >
                  <!-- This appears to be the fix for the additional 1 added to   Dwelling Units
                 <b>{{ (springGardenS == "Yes") ? Math.floor((dwellingUnits)*0.5) : 0 }}</b> -->
                  <b>{{ (springGardenS === $t('message.no')) ? 0 : additionalModerateUnitsEarned }}</b>
                </p>
                <!-- <p>
                <b>{{ additionalModerateUnitsEarned }}</b>
              </p> -->
              </div>
            </div>
          </div>

          <div
            v-if="overlays.includes($t('message.overlay.greenRoof'|| overlays == undefined))"
            class="columns is-centered"
          >
            <div class="column">
              <p style="margin-left: 3%">
                {{ $t("message.greenRoofBonus") }}
              </p>
            </div>
            <div class="column">
              <p
                style="margin-left: 0.35%"
                class="line-indent"
              >
                <b>{{ greenRoofBonusUnits }}</b>
              </p>
            </div>
          </div>

          <div 
            v-if="affordabilityLevel === $t('message.affordability.moderateIncome')" 
            class="columns is-centered"
          >
            <div class="column">
              <p style="margin-left:3%">
                {{ $t("message.modIncomePayment") }}
              </p>
            </div>
            <div class="column">
              <p class="line-indent">
                <b> ${{ Number(moderateIncomeEstimatedPayment).toLocaleString() }}</b>
              </p>
            </div>
          </div>

          <div
            v-if="affordabilityLevel === $t('message.affordability.lowIncome')" 
            class="columns is-centered"
          >
            <div class="column">
              <p style="margin-left: 3%">
                {{ $t("message.lowIncomePayment") }}
              </p>
            </div>
            <div class="column">
              <p
                style="margin-left: 0.35%"
                class="line-indent"
              >
                <b>${{ Number(lowIncomeEstimatedPayment).toLocaleString() }}</b>
              </p>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <p
                style="margin-left: 3%"
              >
                {{ $t("message.totalUnits") }}
              </p>
            </div>

            <!--<div class="columns">
              <div
                v-if="overlays.includes($t('message.overlay.greenRoof')) && overlays.includes($t('message.overlay.minMixed'))"
              >
                <p
                  class="line-indent"
                  style="margin-left: 3%"
                >
                  <b>{{ Math.floor(totalNumberOfUnits) }}</b>
                </p>
              </div>
              <div v-else>

              </div>
            </div> -->
            <div class="column">
              <div v-if="shouldShowTotalUnits">
                <p 
                  class="line-indent" 
                  style="margin-left: 0.5%"
                >
                  <b>{{ totalUnitsToDisplay }}</b>
                </p>
              </div>
            </div>
          </div>

          <div v-if="affordabilityLevel === $t('message.affordability.lowIncome') && (springGardenS == $t('message.yes') || overlays.includes($t('message.overlay.societyHill')) || overlays.includes($t('message.overlay.minMixed')) || overlays.includes($t('message.overlay.todDevelopement')))">
            <div class="columns is-centered">
              <div class="column">
                <p style="margin-left:3%">
                  {{ $t("message.requiredAffordableUnits") }}
                </p>
              </div>
              <div class="column">
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ (requiredAffordableUnitsLow) }}</b>
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="affordabilityLevel === $t('message.affordability.lowIncome') && overlays.includes($t('message.overlay.greenRoof'))">
            <div class="columns is-centered">
              <div class="column">
                <p style="margin-left:3%">
                  {{ $t("message.requiredAffordableUnits") }}
                </p>
              </div>
              <div class="column">
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ (requiredAffordableUnitsLow) }}</b>
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="affordabilityLevel === $t('message.affordability.lowIncome') && !overlays.includes($t('message.overlay.minMixed')) && !overlays.includes($t('message.overlay.todDevelopement')) && !overlays.includes($t('message.overlay.societyHill')) && !overlays.includes($t('message.overlay.greenRoof'))">
            <div class="columns is-centered">
              <div class="column">
                <p style="margin-left: 3%">
                  {{ $t("message.requiredAffordableUnits") }}
                </p>
              </div>
              <div class="column">
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ (springGardenS === $t('message.no')) ? 0 : Math.ceil((dwellingUnits + additionalLowUnitsEarned) * 0.1) }}</b>
                </p>
              </div>
            </div>
          </div>

          <div v-if="affordabilityLevel === $t('message.affordability.moderateIncome') && (springGardenS == $t('message.yes') || overlays.includes($t('message.overlay.societyHill')) || overlays.includes($t('message.overlay.minMixed')) || overlays.includes($t('message.overlay.todDevelopement')))">
            <div class="columns is-centered">
              <div class="column">
                <p style="margin-left:3%">
                  {{ $t("message.requiredAffordableUnits") }}
                </p>
              </div>
              <div class="column">
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ (requiredAffordableUnitsMod) }}</b>
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="affordabilityLevel === $t('message.affordability.moderateIncome') && overlays.includes($t('message.overlay.greenRoof'))">
            <div class="columns is-centered">
              <div class="column">
                <p style="margin-left:3%">
                  {{ $t("message.requiredAffordableUnits") }}
                </p>
              </div>
              <div class="column">
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ (requiredAffordableUnitsMod) }}</b>
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="affordabilityLevel === $t('message.affordability.moderateIncome') && !overlays.includes($t('message.overlay.minMixed')) && !overlays.includes($t('message.overlay.todDevelopement')) && !overlays.includes($t('message.overlay.societyHill')) && !overlays.includes($t('message.overlay.greenRoof'))">
            <div class="columns is-centered">
              <div class="column">
                <p style="margin-left: 3%">
                  {{ $t("message.requiredAffordableUnits") }}
                </p>
              </div>
              <div class="column">
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ (springGardenS === $t('message.no')) ? 0 : Math.ceil((dwellingUnits + additionalModerateUnitsEarned) * 0.1) }}</b>
                </p>
              </div>
            </div>
          </div>

          <div v-if="affordabilityLevel === '' && overlays.includes($t('message.overlay.minMixed')) && dwellingUnits >=10 ">
            <div class="columns is-centered">
              <div class="column">
                <p
                  style="margin-left: 3%"
                >
                  {{ $t("message.requiredMinAffordableUnits") }}
                </p>
              </div>
              <div class="column">
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ requiredMinAffordableUnits }}</b>
                </p>
              </div>
            </div>
          </div>

          <div v-if="affordabilityLevel === $t('message.affordability.lowIncome') && overlays.includes($t('message.overlay.minMixed')) && totalNumberOfUnitsLow >=10 ">
            <div class="columns is-centered">
              <div class="column">
                <p
                  style="margin-left: 3%"
                >
                  {{ $t("message.requiredMinAffordableUnits") }}
                </p>
              </div>
              <div class="column">
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ requiredMinAffordableUnitsLow }}</b>
                </p>
              </div>
            </div>
          </div>

          <div v-if="affordabilityLevel === $t('message.affordability.moderateIncome') && overlays.includes($t('message.overlay.minMixed')) && totalNumberOfUnitsMod >=10 ">
            <div class="columns is-centered">
              <div class="column">
                <p
                  style="margin-left: 3%"
                >
                  {{ $t("message.requiredMinAffordableUnits") }}
                </p>
              </div>
              <div class="column">
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ requiredMinAffordableUnitsMod }}</b>
                </p>
              </div>
            </div>
          </div>

          <div>
            <div v-if="affordabilityLevel === '' && overlays.includes($t('message.overlay.minMixed')) && overlays.includes($t('message.overlay.greenRoof')) ">
              <div class="columns is-centered">
                <div class="column">
                  <p
                    style="margin-left: 3%"
                  >
                    {{ $t("message.totalRequiredAffordabilityUnits") }}
                  </p>
                </div>
                <div class="column">
                  <p
                    class="line-indent"
                    style="margin-left: 0.5%"
                  >
                    <b>{{ Math.ceil(totalNumberOfUnits * 0.2) }}</b>
                  </p>
                </div>
              </div>
            </div>

            <div v-else-if="affordabilityLevel === '' && overlays.includes($t('message.overlay.minMixed')) && dwellingUnits >=10 ">
              <div class="columns is-centered">
                <div class="column">
                  <p
                    style="margin-left: 3%"
                  >
                    {{ $t("message.totalRequiredAffordabilityUnits") }}
                  </p>
                </div>
                <div class="column">
                  <p
                    class="line-indent"
                    style="margin-left: 0.5%"
                  >
                    <b>{{ requiredTotalAffordableUnits }}</b>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="affordabilityLevel === $t('message.affordability.lowIncome') && overlays.includes($t('message.overlay.minMixed')) && totalNumberOfUnitsLow >=10 ">
            <div class="columns is-centered">
              <div class="column">
                <p
                  style="margin-left: 3%"
                >
                  {{ $t("message.totalRequiredAffordabilityUnits") }}
                </p>
              </div>
              <div class="column">
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ requiredTotalAffordableUnitsLow }}</b>
                </p>
              </div>
            </div>
          </div>

          <div v-if="affordabilityLevel === $t('message.affordability.moderateIncome') && overlays.includes($t('message.overlay.minMixed')) && totalNumberOfUnitsMod >=10 ">
            <div class="columns is-centered">
              <div class="column">
                <p
                  style="margin-left: 3%"
                >
                  {{ $t("message.totalRequiredAffordabilityUnits") }}
                </p>
              </div>
              <div class="column">
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ requiredTotalAffordableUnitsMod }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- This is where FAR district output begins -->
        <div 
          v-if="(zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && affordabilityLevel === $t('message.affordability.lowIncome')" 
          class="column"
        >
          <div class="columns is-centered">
            <div class="column">
              <p style="margin-left: 1%">
                {{ $t("message.additionalFar") }} 
              </p>
            </div>
            <div class="column">
              <div> 
                <p
                  class="line-indent"
                  style="margin-left: 0%"
                >
                  <b>{{ additionalFarLowEarned }}%</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div 
          v-if="(zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && affordabilityLevel === $t('message.affordability.moderateIncome')" 
          class="column"
        >
          <div class="columns is-centered">
            <div class="column">
              <p style="margin-left: 1%">
                {{ $t("message.additionalFar") }} 
              </p>
            </div>
            <div class="column">
              <div> 
                <p
                  class="line-indent"
                  style="margin-left: 0%"
                >
                  <b>{{ additionalFarModEarned }}%</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="(zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX') && overlays==($t('message.overlay.todDevelopement'))">
          <div class="columns is-centered">
            <div class="column">
              <p style="margin-left: 3%">
                {{ $t("message.totalFar") }}
              </p>
            </div>
            <div class="column">
              <div>
                <p
                  class="line-indent"
                  style="margin-left: 0%"
                >
                  <b>{{ "N/A" }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div 
          v-if="(zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && affordabilityLevel === $t('message.affordability.lowIncome')" 
        >
          <div class="columns is-centered">
            <div class="column">
              <p style="margin-left: 3%">
                {{ $t("message.totalFar") }}
              </p>
            </div>
            <div class="column">
              <div>
                <p
                  class="line-indent"
                  style="margin-left: 0%"
                >
                  <b>{{ totalFarLow }}%</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div 
          v-if="(zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && affordabilityLevel === $t('message.affordability.moderateIncome')" 
        >
          <div class="columns is-centered">
            <div class="column">
              <p style="margin-left: 3%">
                {{ $t("message.totalFar") }}
              </p>
            </div>
            <div class="column">
              <div>
                <p
                  class="line-indent"
                  style="margin-left: 0%"
                >
                  <b>{{ totalFarMod }}%</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="(zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && affordabilityLevel === $t('message.affordability.lowIncome')" 
        >
          <div class="columns is-centered">
            <div class="column">
              <p style="margin-left: 3%">
                {{ $t("message.totalFloor") }}
              </p>
            </div>

            <div class="column">
              <div>
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ floorAreaBonusLow.toLocaleString() }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="(zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && affordabilityLevel === $t('message.affordability.moderateIncome')" 
        >
          <div class="columns is-centered">
            <div class="column">
              <p style="margin-left: 3%">
                {{ $t("message.totalFloor") }}
              </p>
            </div>

            <div class="column">
              <div>
                <p
                  class="line-indent"
                  style="margin-left: 0.5%"
                >
                  <b>{{ floorAreaBonusModerate.toLocaleString() }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- <div
            v-if="overlays.includes('This project will earn a Green Roof Bonus'|| overlays == undefined)"
            class="columns is-centered"
          >
            <div class="column">
              <p style="margin-left: 3%">
                Number of Green Roof Bonus Units: 
              </p>
            </div>
            <div class="column">
              <p
                style="margin-left: 0.35%"
                class="line-indent"
              >
                <b>{{ greenRoofBonusUnits }}</b>
              </p>
            </div>
          </div> -->

        <div 
          v-if="(zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && affordabilityLevel === $t('message.affordability.moderateIncome')"
          class="columns is-centered"
        >
          <div class="column">
            <p style="margin-left:3%">
              {{ $t("message.modIncomePayment") }}
            </p>
          </div>
          <div class="column">
            <p class="line-indent">
              <b> ${{ Number(moderateIncomeEstimatedPayment).toLocaleString() }}</b>
            </p>
          </div>
        </div>

        <div
          v-if="(zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && affordabilityLevel === $t('message.affordability.lowIncome')" 
          class="columns is-centered"
        >
          <div class="column">
            <p style="margin-left: 3%">
              {{ $t("message.lowIncomePayment") }}
            </p>
          </div>
          <div class="column">
            <p
              style="margin-left: 0.35%"
              class="line-indent"
            >
              <b>${{ Number(lowIncomeEstimatedPayment).toLocaleString() }}</b>
            </p>
          </div>
        </div>
            
        <div
          v-if="((zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && affordabilityLevel === $t('message.affordability.lowIncome'))"
        >
          <div
            class="
            columns
            is-centered"
          >
            <div class="column">
              <p style="margin-left:3%">
                {{ $t("message.requiredAffordableUnits") }}
              </p>
            </div>
            <div class="column">
              <p
                class="line-indent"
                style="margin-left: 0.5%"
              >
                <b>{{ (requiredAffordableUnitsLow) }}</b>
              </p>
            </div>
          </div>
        </div>

        <div
          v-if="((zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && affordabilityLevel === $t('message.affordability.moderateIncome'))"
        >
          <div
            class="
            columns
            is-centered"
          >
            <div class="column">
              <p style="margin-left:3%">
                {{ $t("message.requiredAffordableUnits") }}
              </p>
            </div>
            <div class="column">
              <p
                class="line-indent"
                style="margin-left: 0.5%"
              >
                <b>{{ (requiredAffordableUnitsMod) }}</b>
              </p>
            </div>
          </div>
        </div>

        <div v-if="(zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && overlays.includes($t('message.overlay.minMixed')) && totalFarUnits >=10">
          <div class="columns is-centered">
            <div class="column">
              <p
                style="margin-left: 3%"
              >
                {{ $t("message.requiredMinAffordableUnits") }}
              </p>
            </div>
            <div class="column">
              <p
                class="line-indent"
                style="margin-left: 0.5%"
              >
                <b>{{ Math.ceil(totalFarUnits * .2) }}</b>
              </p>
            </div>
          </div>
        </div>

        <div v-if="((zoningDistrict === 'RM-2' || zoningDistrict === 'RM-3' || zoningDistrict === 'RMX-1' || zoningDistrict === 'RM-4' || zoningDistrict === 'RMX-2' || zoningDistrict === 'IRMX' || zoningDistrict === 'RMX-3'|| zoningDistrict === 'CMX-3' || zoningDistrict === 'CMX-4' || zoningDistrict === 'CMX-5') && overlays.includes($t('message.overlay.minMixed')) && (affordabilityLevel === $t('message.affordability.lowIncome') || (affordabilityLevel=== $t('message.affordability.moderateIncome') && totalFarUnits >=10)))">
          <div class="columns is-centered">
            <div class="column">
              <p
                style="margin-left: 3%"
              >
                {{ $t("message.totalRequiredAffordabilityUnits") }}
              </p>
            </div>
            <div class="column">
              <p
                class="line-indent"
                style="margin-left: 0.5%"
              >
                <b>{{ affordabilityLevel === $t('message.affordability.lowIncome') ? Math.ceil((totalFarUnits * 0.2) + requiredAffordableUnitsLow) : affordabilityLevel === $t('message.affordability.moderateIncome') ? Math.ceil((totalFarUnits * 0.2) + requiredAffordableUnitsMod) : 0 }}</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import options from "@/utilities/options.js";
import { Textbox } from "@phila/phila-ui";
export default {
  name: "Home",
  components: { Textbox },
  mixins: [options],
  //components: {},
  data() {
    return {
      zoningDistrict: null,
      lotAreaSqFeet: null,
      buildingHeight: null,
      earthDisturbance: null,
      springGardenS: " ",
      baseFloorArea: null,
      affordabilityLevel: '',
      sFHA: null,
      totalFarUnits: "",
      overlays: [],
      supportedLanguages: ['en', 'es'],
      selectedLanguage: this.$i18n.locale,
    };
  },
  //msg: String,
  computed: {
    shouldShowTotalUnits() {
      return this.affordabilityLevel === '' || 
            this.affordabilityLevel === this.$i18n.t('message.affordability.lowIncome') || 
            this.affordabilityLevel === this.$i18n.t('message.affordability.moderateIncome');
    },

    totalUnitsToDisplay() {
      if (this.affordabilityLevel === '') {
        return this.totalNumberOfUnits;
      } else if (this.affordabilityLevel === this.$i18n.t('message.affordability.lowIncome')) {
        return this.totalNumberOfUnitsLow;
      } else if (this.affordabilityLevel === this.$i18n.t('message.affordability.moderateIncome')) {
        return this.totalNumberOfUnitsMod;
      }
      return 0;
    },

    totalNumberOfUnits() {
      if (this.overlays.includes(this.$i18n.t('message.overlay.greenRoof')) && 
          this.overlays.includes(this.$i18n.t('message.overlay.minMixed'))) {
        return Math.floor(this.dwellingUnits + this.greenRoofBonusUnits);
      }
      return this.dwellingUnits;
    },
    // totalNumberOfUnits: function() {
    //   console.log("HERE");
    //   if ((this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.overlays.includes(this.$i18n.t('message.overlay.greenRoof')))) {
    //     return Math.floor((this.dwellingUnits + this.greenRoofBonusUnits));
    //   }
    //   return 0;
    // },

    totalNumberOfUnitsLow: function() {
      // if(this.overlays.includes('This project is within the Fifth District Overlay District (/VDO)')){ 
      //   return 0;
      // }
      const translatedNo = this.$i18n.t('message.no');
      
      if (this.springGardenS === translatedNo && this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return (this.dwellingUnits + this.greenRoofBonusUnits);
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return (this.dwellingUnits + this.additionalLowUnitsEarned + this.greenRoofBonusUnits);
      }
      if(this.springGardenS == translatedNo) {
        return 0;
      }
      // if (this.overlays.includes('Transit Oriented Developement Overlay')) {
      //   return Math.floor(this.dwellingUnits + (this.dwellingUnits * 0.5) * 0.5);
      // }
      if (this.overlays.includes(this.$i18n.t('message.overlay.societyHill'))) {
        return Math.floor(this.dwellingUnits + (this.dwellingUnits * 0.5));
      } else if (this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return Math.floor(this.dwellingUnits + (this.dwellingUnits * 0.5)+ this.greenRoofBonusUnits);
      } 
      // Handle the case when neither condition is met
      return Math.floor(this.dwellingUnits + this.additionalLowUnitsEarned); /* some default value */
    },

    totalNumberOfUnitsMod: function(){
      const translatedNo = this.$i18n.t('message.no');

      if(this.springGardenS == translatedNo && this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return (this.dwellingUnits + this.greenRoofBonusUnits);
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return (this.dwellingUnits + this.additionalModerateUnitsEarned + this.greenRoofBonusUnits);
      }
      if(this.springGardenS == translatedNo) {
        return 0;
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.societyHill'))) {
        return Math.floor(this.dwellingUnits + (this.dwellingUnits * 0.25));
      } else if (this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return Math.floor(this.dwellingUnits + (this.dwellingUnits * 0.25)+ this.greenRoofBonusUnits);
      } 
      // Handle the case when neither condition is met
      return Math.floor(this.dwellingUnits + this.additionalModerateUnitsEarned); /* some default value */
    },

    requiredAffordableUnitsLow: function(){
      const translatedLowIncome = this.$i18n.t('message.affordability.lowIncome');
      const translatedNo = this.$i18n.t('message.no');
      const translatedYes = this.$i18n.t('message.yes');
      if(
        (this.zoningDistrict === 'RM-2' || this.zoningDistrict === 'RM-3' || this.zoningDistrict === 'RMX-1' || this.zoningDistrict === 'RM-4' || this.zoningDistrict === 'RMX-2' || this.zoningDistrict === 'IRMX' || this.zoningDistrict === 'RMX-3'|| this.zoningDistrict === 'CMX-3' || this.zoningDistrict === 'CMX-4' || this.zoningDistrict === 'CMX-5') && this.affordabilityLevel === translatedLowIncome){
        return Math.ceil((this.totalFarUnits) *0.1);
      }
      if(this.springGardenS == translatedYes){
        return Math.ceil((this.totalNumberOfUnitsLow)*0.1);
      } 
      if(this.springGardenS == translatedNo && this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return Math.ceil((this.totalNumberOfUnitsLow)*0.1);
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return Math.ceil((this.dwellingUnits + this.additionalLowUnitsEarned + this.greenRoofBonusUnits) * 0.1 );
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.societyHill'))) {
        return Math.ceil((this.dwellingUnits + this.additionalLowUnitsEarned) *0.1); 
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return Math.ceil((this.dwellingUnits + this.additionalLowUnitsEarned) *0.1);
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.minMixed'))) {
        return Math.ceil((this.dwellingUnits + this.additionalLowUnitsEarned) * 0.1);
      }
      if(!this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && !this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement')) && !this.overlays.includes(this.$i18n.t('message.overlay.societyHill')) && !this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return Math.ceil((this.dwellingUnits + this.additionalLowUnitsEarned) * 0.1);
      }
      return 0;
    },

    requiredAffordableUnitsMod: function(){
      const translatedModIncome = this.$i18n.t('message.affordability.moderateIncome');
      const translatedNo = this.$i18n.t('message.no');
      const translatedYes = this.$i18n.t('message.yes');
      if(
        (this.zoningDistrict === 'RM-2' || this.zoningDistrict === 'RM-3' || this.zoningDistrict === 'RMX-1' || this.zoningDistrict === 'RM-4' || this.zoningDistrict === 'RMX-2' || this.zoningDistrict === 'IRMX' || this.zoningDistrict === 'RMX-3'|| this.zoningDistrict === 'CMX-3' || this.zoningDistrict === 'CMX-4' || this.zoningDistrict === 'CMX-5') && this.affordabilityLevel === translatedModIncome){
        return Math.ceil((this.totalFarUnits) *0.1);
      }
      if(this.springGardenS == translatedYes){
        return Math.ceil((this.totalNumberOfUnitsMod)*0.1);
      } 
      if(this.springGardenS == translatedNo && this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return Math.ceil((this.totalNumberOfUnitsMod)*0.1);
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return Math.ceil((this.dwellingUnits + this.additionalModerateUnitsEarned + this.greenRoofBonusUnits) * 0.1 );
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.societyHill'))) {
        return Math.ceil((this.dwellingUnits + this.additionalModerateUnitsEarned) *0.1); 
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return Math.ceil((this.dwellingUnits + this.additionalModerateUnitsEarned) *0.1);
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.minMixed'))) {
        return Math.ceil((this.dwellingUnits + this.additionalModerateUnitsEarned) * 0.1);
      }
      if(!this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && !this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement')) && !this.overlays.includes(this.$i18n.t('message.overlay.societyHill')) && !this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        return Math.ceil((this.dwellingUnits + this.additionalModerateUnitsEarned) * 0.1);
      }
      return 0;
    },

    requiredMinAffordableUnits: function(){
      if(this.overlays.includes(this.$i18n.t('message.overlay.minMixed'))) {
        if(this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
          return Math.ceil(this.totalNumberOfUnits * 0.2);
        }
        return Math.ceil(this.dwellingUnits * 0.2);
      }
      return 0;
    },

    requiredMinAffordableUnitsLow: function(){
      if(this.overlays.includes(this.$i18n.t('message.overlay.minMixed'))) {
        return Math.ceil(this.totalNumberOfUnitsLow * .2);
      }
      return 0;
    },

    requiredMinAffordableUnitsMod: function(){
      if(this.overlays.includes(this.$i18n.t('message.overlay.minMixed'))) {
        return Math.ceil(this.totalNumberOfUnitsMod * .2);
      }
      return 0;
    },

    requiredTotalAffordableUnits: function(){
      if(this.overlays.includes(this.$i18n.t('message.overlay.minMixed'))) {
        if(this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
          return Math.ceil(this.totalNumberOfUnits * 0.2);
        }
        return Math.ceil(this.dwellingUnits * 0.2);
      }
      return 0;
    },

    requiredTotalAffordableUnitsLow: function(){
      if(this.overlays.includes(this.$i18n.t('message.overlay.minMixed'))) {
        return this.requiredAffordableUnitsLow + this.requiredMinAffordableUnitsLow;
      }
      return 0;
    },

    requiredTotalAffordableUnitsMod: function(){
      if(this.overlays.includes(this.$i18n.t('message.overlay.minMixed'))) {
        return this.requiredAffordableUnitsMod + this.requiredMinAffordableUnitsMod;
      }
      return 0;
    },

    dwellingUnits: function () {
      const translatedModIncome = this.$i18n.t('message.affordability.moderateIncome');
      const minMixedOverlay = this.$i18n.t('message.overlay.minMixed');
      const todOverlay = this.$i18n.t('message.overlay.todDevelopement');
      const translatedYes = this.$i18n.t('message.yes');
      let baseUnits = 0;

      if (this.overlays.includes(minMixedOverlay) && this.overlays.includes(todOverlay)) {
        // Apply minMixed logic first
        if (this.zoningDistrict === "RM-1") {
          if (this.lotAreaSqFeet >= 2880) {
            baseUnits = Math.floor(((this.lotAreaSqFeet - 1440) / 320) + 1440 / 240);
          } else {
            baseUnits = Math.floor(this.lotAreaSqFeet / 480);
          }
        } else if (this.zoningDistrict === "CMX-2.5") {
          if (this.buildingHeight <= 45 && this.lotAreaSqFeet >= 2520) {
            baseUnits = Math.floor(this.lotAreaSqFeet / 240);
          } else if (this.buildingHeight > 45 && this.lotAreaSqFeet >= 1890) {
            baseUnits = Math.floor(this.lotAreaSqFeet / 180);
          }
        } else if (this.zoningDistrict === "CMX-2" && this.lotAreaSqFeet >= 3360) {
          baseUnits = Math.floor(this.lotAreaSqFeet / 320);
        } else if (this.zoningDistrict === "CMX-1" && this.lotAreaSqFeet >= 3360) {
          baseUnits = Math.floor(this.lotAreaSqFeet / 320);
        }

        // Apply 50% increase from todDevelopement
        return Math.floor(baseUnits * 1.5);
      }

      if (
        (this.affordabilityLevel === translatedModIncome &&(this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.zoningDistrict == "RM-1")&& this.lotAreaSqFeet >=3360)) {
        return Math.floor(((this.lotAreaSqFeet - 1440)/ 320) + 1440 / 240);
      }
      if (
        (this.affordabilityLevel === translatedModIncome &&(this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.zoningDistrict == "RM-1")&& this.lotAreaSqFeet <3360)) {
        return Math.floor(((this.lotAreaSqFeet - 1440) / 480) + 4);
      }
      const translatedLowIncome = this.$i18n.t('message.affordability.lowIncome');
      if ((this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.zoningDistrict == "RM-1")&& this.lotAreaSqFeet >=2880) {
        return Math.floor(((this.lotAreaSqFeet - 1440)/ 320) + 1440 / 240);
      }

      if (
        (this.affordabilityLevel === translatedLowIncome &&(this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.zoningDistrict == "RM-1")&& this.lotAreaSqFeet >2880)) {
        return Math.floor(((this.lotAreaSqFeet - 1440)/ 320) + 1440 / 240);
      }
      if (
        (this.affordabilityLevel === translatedLowIncome &&(this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.zoningDistrict == "RM-1")&& this.lotAreaSqFeet <2880)) {
        return Math.floor(((this.lotAreaSqFeet - 1440) / 480) + 4);
      }
      if ((this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.zoningDistrict == "RM-1")&& this.lotAreaSqFeet <3360 && this.dwellingUnits >=10) {
        
        return Math.floor(this.lotAreaSqFeet / 480);
        
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement')) && this.zoningDistrict == "RM-1" && this.lotAreaSqFeet <= 1440) {
        var baseUnitsTod = Math.floor(this.lotAreaSqFeet / 360);
        return Math.floor(baseUnitsTod + (baseUnitsTod * 0.5));
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement')) && this.zoningDistrict == "RM-1" && this.lotAreaSqFeet > 1440) {
        var baseUnitsTo = Math.floor(((this.lotAreaSqFeet - 1440) / 480) +4);
        return Math.floor(baseUnitsTo + (baseUnitsTo * 0.5));
      }
      if (this.zoningDistrict == "RM-1" && this.lotAreaSqFeet <= 1440) {
        return Math.floor(this.lotAreaSqFeet / 360);
      }
      if (this.zoningDistrict == "RM-1" && this.lotAreaSqFeet > 1440) {
        return Math.floor(((this.lotAreaSqFeet - 1440) / 480) + 4);
      }
      if (this.zoningDistrict == "RM-1") {
        return Math.floor(this.lotAreaSqFeet / 480);
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement')) && this.zoningDistrict == "CMX-2.5" && this.buildingHeight <= 45) {
        var baseUnitsC = Math.floor(this.lotAreaSqFeet / 360);
        return Math.floor(baseUnitsC + (baseUnitsC * 0.5));
      }
      if ((this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.zoningDistrict == "CMX-2.5" && this.buildingHeight <= 45)&& this.lotAreaSqFeet >=2520) {
        var baseUnitsTw = Math.floor(this.lotAreaSqFeet / 240);
        if (baseUnitsTw >=10){
          return Math.floor(baseUnitsTw);
        }
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement')) && this.zoningDistrict == "CMX-2.5" && this.buildingHeight > 45) {
        var baseUnitsCm = Math.floor(this.lotAreaSqFeet / 270);
        return Math.floor(baseUnitsCm + (baseUnitsCm * 0.5));
      }
      if ((this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.zoningDistrict == "CMX-2.5" && this.buildingHeight > 45)&& this.lotAreaSqFeet >=1890) {
        var baseUnitsTwo = Math.floor(this.lotAreaSqFeet / 180);
        if (baseUnitsTwo >=10){
          return baseUnitsTwo;
        } {
          return Math.floor(this.lotAreaSqFeet / 270);
        }
      }
      if (this.zoningDistrict == "CMX-2.5" && this.buildingHeight > 45) {
        return Math.floor(this.lotAreaSqFeet / 270);
      }
      if (this.zoningDistrict == "CMX-2.5" && this.buildingHeight <= 45) {
        return Math.floor(this.lotAreaSqFeet / 360);
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement')) && this.zoningDistrict == "CMX-2") {
        var baseUnitsT = Math.floor(this.lotAreaSqFeet / 480);
        return Math.floor(baseUnitsT + (baseUnitsT * 0.5));
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.societyHill')) && this.zoningDistrict == "CMX-2") {
        return Math.floor(this.lotAreaSqFeet / 360);
      }
      if (this.zoningDistrict == "CMX-2" && this.affordabilityLevel == translatedModIncome && (this.overlays.includes(this.$i18n.t('message.overlay.minMixed')&& this.lotAreaSqFeet <3840))) {
        return Math.floor(this.lotAreaSqFeet / 480);
      }
      if ((this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.zoningDistrict == "CMX-2")&& this.lotAreaSqFeet <3360) {
        return Math.floor(this.lotAreaSqFeet / 480);
      }
      if ((this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.zoningDistrict == "CMX-2")&& this.lotAreaSqFeet >=3360) {
        return Math.floor(this.lotAreaSqFeet / 320);
      }
      if (this.zoningDistrict == "CMX-2") {
        return Math.floor(this.lotAreaSqFeet / 480);
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement')) && this.zoningDistrict == "CMX-1") {
        var baseUnitsCmx = Math.floor(this.lotAreaSqFeet / 480);
        return Math.floor(baseUnitsCmx + (baseUnitsCmx * 0.5));
      }
      if ((this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.zoningDistrict == "CMX-1") && this.lotAreaSqFeet >=3360) {
        return Math.floor(this.lotAreaSqFeet / 320);
      }
      if (this.zoningDistrict == "CMX-1") {
        return Math.floor(this.lotAreaSqFeet / 480);
      }
      return 0;
    },

    baseFar: function () {
      const translatedYes = this.$i18n.t('message.yes');

      if ((this.zoningDistrict == "RM-2" && this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict')) && this.springGardenS == translatedYes)) {
        return (70);
      }
      if (this.zoningDistrict == "RM-2" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))){
        return (120);
      }
      if (this.zoningDistrict == "RM-2" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits >=10) {
        return (120);
      } else if(this.zoningDistrict == "RM-2" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits < 10) {
        return (70);
      }
      if (this.zoningDistrict == "RM-2") {
        return (70);
      }
      if ((this.zoningDistrict == "RM-3" && this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict')) && this.springGardenS == translatedYes)) {
        return (150);
      }
      if (this.zoningDistrict == "RM-3" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (225);
      }
      if (this.zoningDistrict == "RM-3" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits >=10) {
        return (225);
      } else if(this.zoningDistrict == "RM-3" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits < 10) {
        return (150);
      }
      if (this.zoningDistrict == "RM-3") {
        return (150);
      }
      if ((this.zoningDistrict == "RMX-1" && this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict')) && this.springGardenS == translatedYes)) {
        return (150);
      }
      if (this.zoningDistrict == "RMX-1" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (225);
      }
      if (this.zoningDistrict == "RMX-1" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits >=10) {
        return (225);
      } else if(this.zoningDistrict == "RMX-1" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits < 10) {
        return (150);
      }
      if (this.zoningDistrict == "RMX-1") {
        return (150);//need explanation of 150 of district area, excluding streets
      }
      if ((this.zoningDistrict == "RM-4" && this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict')) && this.springGardenS == translatedYes)) {
        return (350);
      }
      if (this.zoningDistrict == "RM-4" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (525);
      }
      if (this.zoningDistrict == "RM-4" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits >=10) {
        return (525);
      } else if(this.zoningDistrict == "RM-4" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits < 10) {
        return (350);
      }
      if (this.zoningDistrict == "RM-4") {
        return (350);
      }
      if ((this.zoningDistrict == "RMX-2" && this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict')) && this.springGardenS == translatedYes)) {
        return (250);
      }
      if (this.zoningDistrict == "RMX-2" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (375);
      }
      if (this.zoningDistrict == "RMX-2" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits >=10) {
        return (375);
      } else if(this.zoningDistrict == "RMX-2" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits < 10) {
        return (250);
      }
      if (this.zoningDistrict == "RMX-2") {
        return (250); //need explanation of 250 of district area, excluding streets
      }
      if (this.zoningDistrict == "IRMX" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (750);
      }
      if ((this.zoningDistrict == "IRMX" && this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict')) && this.springGardenS == translatedYes)) {
        return (500);
      }
      if (this.zoningDistrict == "IRMX" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits >=10) {
        return (750);
      } else if(this.zoningDistrict == "IRMX" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits < 10) {
        return (500);
      }
      if (this.zoningDistrict == "IRMX") {
        return (500);
      }
      if ((this.zoningDistrict == "RMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict')) && this.springGardenS == translatedYes)) {
        return (500);
      }
      // if (this.zoningDistrict == "RMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
      //   return (800);
      // }
      if (this.zoningDistrict == "RMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits >=10) {
        return (750);
      } else if(this.zoningDistrict == "RMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits < 10) {
        return (500);
      }
      if ((this.zoningDistrict == "RMX-3") && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (530);
      }
      if (this.zoningDistrict == "RMX-3") {
        return (500);
      }
      if ((this.zoningDistrict == "CMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict')) && this.springGardenS == translatedYes)) {
        return (500);
      }
      if (this.zoningDistrict == "CMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (800);
      }
      if (this.zoningDistrict == "CMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits >=10) {
        return (750);
      } else if(this.zoningDistrict == "CMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits < 10) {
        return (500);
      }
      if ((this.zoningDistrict == "CMX-3") && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (530);
      }
      if (this.zoningDistrict == "CMX-3") {
        return (500);
      }
      if ((this.zoningDistrict == "CMX-4" && this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict')) && this.springGardenS == translatedYes)) {
        return (500);
      }
      if (this.zoningDistrict == "CMX-4" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (750);
      }
      if (this.zoningDistrict == "CMX-4" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits >=10) {
        return (750);
      } else if(this.zoningDistrict == "CMX-4" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits < 10) {
        return (500);
      }
      if ((this.zoningDistrict == "CMX-4") && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (530);
      }
      if (this.zoningDistrict == "CMX-4") {
        return (500);
      }
      if ((this.zoningDistrict == "CMX-5" && this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict')) && this.springGardenS == translatedYes)) {
        return (1200);
      }
      if (this.zoningDistrict == "CMX-5" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (1600);
      }
      if (this.zoningDistrict == "CMX-5" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits >=10) {
        return (1600);
      } else if(this.zoningDistrict == "CMX-5" && this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) && this.totalFarUnits < 10) {
        return (1200);
      }
      if (this.zoningDistrict == "CMX-5" && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return (1230);
      }
      if (this.zoningDistrict == "CMX-5") {
        return (1200);
      }
      return 0;
    },

    floorAreaBonusLow: function () {
      const translatedLowIncome = this.$i18n.t('message.affordability.lowIncome');
      const translatedNo = this.$i18n.t('message.no');
      if (
        ((this.zoningDistrict == 'RM-2' || this.zoningDistrict === 'RM-3' || this.zoningDistrict === 'RMX-1' || this.zoningDistrict === 'RM-4' || this.zoningDistrict === 'RMX-2' || this.zoningDistrict === 'IRMX' || this.zoningDistrict === 'RMX-3'|| this.zoningDistrict === 'CMX-3' || this.zoningDistrict === 'CMX-4' || this.zoningDistrict === 'CMX-5') && this.affordabilityLevel === translatedLowIncome) && this.springGardenS == translatedNo) {
        return ((this.baseFar / 100) * this.lotAreaSqFeet);
      }
      if (this.zoningDistrict == "RM-2") {
        return ((this.baseFar / 100) + 0.5) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "RM-3") {
        return ((this.baseFar / 100) + 0.75) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "RMX-1") {
        return ((this.baseFar / 100) + 0.75) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "RM-4") {
        return ((this.baseFar / 100) + 1.75) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "RMX-2") {
        return ((this.baseFar / 100) + 1.25) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "IRMX") {
        return ((this.baseFar / 100) + 2.5) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "RMX-3") {
        return ((this.baseFar / 100) + 2.5) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "CMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return ((this.baseFar / 100) + 3) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "CMX-3") {
        return ((this.baseFar / 100) + 2.5) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "CMX-4") {
        return ((this.baseFar / 100) + 2.5) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "CMX-5") {
        return ((this.baseFar / 100) + 4) * this.lotAreaSqFeet;
      }
      return 0;
    },
    floorAreaBonusModerate: function () {
      const translatedNo = this.$i18n.t('message.no');
      const translatedModIncome = this.$i18n.t('message.affordability.moderateIncome');
      if (((this.zoningDistrict == 'RM-2' || this.zoningDistrict === 'RM-3' || this.zoningDistrict === 'RMX-1' || this.zoningDistrict === 'RM-4' || this.zoningDistrict === 'RMX-2' || this.zoningDistrict === 'IRMX' || this.zoningDistrict === 'RMX-3'|| this.zoningDistrict === 'CMX-3' || this.zoningDistrict === 'CMX-4' || this.zoningDistrict === 'CMX-5') && this.affordabilityLevel === translatedModIncome) && this.springGardenS == translatedNo) {
        return ((this.baseFar / 100) * this.lotAreaSqFeet);
      }
      if (this.zoningDistrict == "RM-2") {
        return ((this.baseFar / 100) + 0.25) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "RM-3") {
        return ((this.baseFar / 100) + 0.5) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "RMX-1") {
        return ((this.baseFar / 100) + 0.5) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "RM-4") {
        return ((this.baseFar / 100) + 1) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "RMX-2") {
        return ((this.baseFar / 100) + 0.75) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "IRMX") {
        return ((this.baseFar / 100) + 1.5) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "RMX-3") {
        return ((this.baseFar / 100) + 1.5) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "CMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return ((this.baseFar / 100) + 2) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "CMX-3") {
        return ((this.baseFar / 100) + 1.5) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "CMX-4") {
        return ((this.baseFar / 100) + 1.5) * this.lotAreaSqFeet;
      }
      if (this.zoningDistrict == "CMX-5") {
        return ((this.baseFar / 100) + 3) * this.lotAreaSqFeet;
      }
      return 0;
    },

    additionalFarLowEarned: function () {
      if (this.zoningDistrict == "RM-2") {
        return  (50);
      }
      if (this.zoningDistrict == "RM-3") {
        return  (75);
      }
      if (this.zoningDistrict == "RMX-1") {
        return  (75);
      }
      if (this.zoningDistrict == "RM-4") {
        return  (175);
      }
      if (this.zoningDistrict == "RMX-2") {
        return  (125);
      }
      if (this.zoningDistrict == "IRMX") {
        return  (250);
      }
      if (this.zoningDistrict == "RMX-3") {
        return  (250);
      }
      if (this.zoningDistrict == "CMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return  (300);
      }
      if (this.zoningDistrict == "CMX-3") {
        return  (250);
      }
      if (this.zoningDistrict == "CMX-4") {
        return  (250);
      }
      if (this.zoningDistrict == "CMX-5") {
        return  (400);
      }
      return 0;
    },

    additionalFarModEarned: function () {
      if (this.zoningDistrict == "RM-2") {
        return  (25);
      }
      if (this.zoningDistrict == "RM-3") {
        return  (50);
      }
      if (this.zoningDistrict == "RMX-1") {
        return  (50);
      }
      if (this.zoningDistrict == "RM-4") {
        return  (100);
      }
      if (this.zoningDistrict == "RMX-2") {
        return  (75);
      }
      if (this.zoningDistrict == "IRMX") {
        return  (150);
      }
      if (this.zoningDistrict == "RMX-3") {
        return  (150);
      }
      if (this.zoningDistrict == "CMX-3" && this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return  (200);
      }
      if (this.zoningDistrict == "CMX-3") {
        return  (150);
      }
      if (this.zoningDistrict == "CMX-4") {
        return  (150);
      }
      if (this.zoningDistrict == "CMX-5") {
        return  (300);
      }
      return 0;
    },


    totalFarLow: function() {
      const translatedLowIncome = this.$i18n.t('message.affordability.lowIncome');
      // if ((this.zoningDistrict == "RM-2" || this.zoningDistrict == "RM-3" || this.zoningDistrict == "RM-4" || this.zoningDistrict == "RMX-1" || this.zoningDistrict == "RMX-2" || this.zoningDistrict == "IRMX") && this.overlays.includes('This project is within the /TOD Transit Oriented Developement Overlay')) {
      //   return "N/A";
      // }
      const translatedYes = this.$i18n.t('message.yes');
      const translatedNo = this.$i18n.t('message.no');
      if(this.springGardenS == translatedYes) {
        return this.baseFar + this.additionalFarLowEarned;
      }
      if(this.springGardenS == translatedNo) {
        return this.baseFar;
      }
      if((this.zoningDistrict === 'RM-2' || this.zoningDistrict === 'RM-3' || this.zoningDistrict === 'RMX-1' || this.zoningDistrict === 'RM-4' || this.zoningDistrict === 'RMX-2' || this.zoningDistrict === 'IRMX' || this.zoningDistrict === 'RMX-3'|| this.zoningDistrict === 'CMX-3' || this.zoningDistrict === 'CMX-4' || this.zoningDistrict === 'CMX-5') && this.affordabilityLevel === translatedLowIncome){
        return this.baseFar + this.additionalFarLowEarned;
      }
      return 0;
    },

    totalFarMod: function() {
      const translatedModIncome = this.$i18n.t('message.affordability.moderateIncome');
      // if ((this.zoningDistrict == "RM-2" || this.zoningDistrict == "RM-3" || this.zoningDistrict == "RM-4" || this.zoningDistrict == "RMX-1" || this.zoningDistrict == "RMX-2" || this.zoningDistrict == "IRMX") && this.overlays.includes('This project is within the /TOD Transit Oriented Developement Overlay')) {
      //   return "N/A";
      // }
      const translatedYes = this.$i18n.t('message.yes');
      const translatedNo = this.$i18n.t('message.no');
      
      if(this.springGardenS == translatedYes) {
        return this.baseFar + this.additionalFarModEarned;
      }
      if(this.springGardenS == translatedNo) {
        return this.baseFar;
      }
      if((this.zoningDistrict === 'RM-2' || this.zoningDistrict === 'RM-3' || this.zoningDistrict === 'RMX-1' || this.zoningDistrict === 'RM-4' || this.zoningDistrict === 'RMX-2' || this.zoningDistrict === 'IRMX' || this.zoningDistrict === 'RMX-3'|| this.zoningDistrict === 'CMX-3' || this.zoningDistrict === 'CMX-4' || this.zoningDistrict === 'CMX-5') && this.affordabilityLevel === translatedModIncome){
        return this.baseFar + this.additionalFarModEarned;
      }
      return 0;
    },
   
    greenRoofBonusUnits: function () {
      // if (this.lotAreaSqFeet >= 5000 && this.earthDisturbance >= 5000) {
      //   return Math.floor(this.dwellingUnits * 0.25);
      if ((this.overlays.includes(this.$i18n.t('message.overlay.greenRoof')) || this.overlays.includes(this.$i18n.t('message.overlay.societyHill')) || this.overlays.includes(this.$i18n.t('message.overlay.minMixed')) || this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement')) && this.lotAreaSqFeet >= 5000 )) {
        return Math.floor(this.dwellingUnits * 0.25);
      } 
      return 0;
      
    },
    additionalLowUnitsEarned: function () {
      if (this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return Math.floor( this.dwellingUnits * 0.5);
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.minMixed'))){
        return Math.floor( this.dwellingUnits * 0.5); 
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.societyHill'))) {
        return Math.floor( this.dwellingUnits * 0.5 );
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict'))){ 
        return Math.floor( this.dwellingUnits * 0.5 ); 
      }
      return Math.floor(this.dwellingUnits* 0.5);
    },

    additionalModerateUnitsEarned: function () {
      if (this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement'))) {
        return Math.floor( this.dwellingUnits * 0.25);
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.minMixed'))){
        return Math.floor( this.dwellingUnits * 0.25); 
      }
      if (this.overlays.includes(this.$i18n.t('message.overlay.societyHill'))) {
        return Math.floor( this.dwellingUnits * 0.25 );
      }
      if(this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict'))){ 
        return Math.floor( this.dwellingUnits * 0.25 ); 
      }
      return Math.floor(this.dwellingUnits* 0.25);
    },

    lowIncomeEstimatedPayment: function () {
      if(this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict'))){ 
        return 0; 
      }
      if (this.zoningDistrict == "CMX-2") {
        return (this.dwellingUnits + this.additionalLowUnitsEarned) * 17700; 
      }
      if (this.zoningDistrict == "RM-1" || this.zoningDistrict == "CMX-1" || this.zoningDistrict == "CMX-2.5") {
        return (this.dwellingUnits + this.additionalLowUnitsEarned) * 17700;
      }
      if (this.zoningDistrict == "RM-2" || this.zoningDistrict == "RM-3" || this.zoningDistrict == "RMX-1" || this.zoningDistrict == "RM-4" || this.zoningDistrict == "RMX-2" || this.zoningDistrict == "IRMX" || this.zoningDistrict == "RMX-3" || this.zoningDistrict == "CMX-3" || this.zoningDistrict == "CMX-4" || this.zoningDistrict == "CMX-5") {
        return (this.floorAreaBonusLow * 14.6);
      }
      return 0;
    },
    moderateIncomeEstimatedPayment: function () {
      if(this.overlays.includes(this.$i18n.t('message.overlay.fithDistrict'))){ 
        return 0; 
      }
      if (this.zoningDistrict == "CMX-2") {
        return (this.dwellingUnits + this.additionalModerateUnitsEarned) * 13600;
      }
      if (this.zoningDistrict == "RM-1" || this.zoningDistrict == "CMX-1" || this.zoningDistrict == "CMX-2.5") {
        return (this.dwellingUnits + this.additionalModerateUnitsEarned) * 13600;
      }
      if (this.zoningDistrict == "RM-2" || this.zoningDistrict == "RM-3" || this.zoningDistrict == "RMX-1" || this.zoningDistrict == "RM-4" || this.zoningDistrict == "RMX-2" || this.zoningDistrict == "IRMX" || this.zoningDistrict == "RMX-3" || this.zoningDistrict == "CMX-3" || this.zoningDistrict == "CMX-4" || this.zoningDistrict == "CMX-5") {
        return (this.floorAreaBonusModerate * 11.3);
      }
      return 0;
    },
    transitOrientedDevelopement: function () {
      if(this.overlays.includes(this.$i18n.t('message.overlay.todDevelopement')) && (this.zoningDistrict === 'RM-1' || this.zoningDistrict === 'CMX-1' || this.zoningDistrict === 'CMX-2' || this.zoningDistrict === 'CMX-2.5')) {
        return this.dwellingUnits*50;
      }
      return 0;
    },
    // totalUnits: function () {
    //   if (this.overlays== ('This project will earn a Green Roof Bonus') && this.lotAreaSqFeet >= 5000) {
    //     return Math.floor ((this.dwellingUnits * 0.5) + (this.dwellingUnits + this.additionalLowUnitsEarned + this.greenRoofBonusUnits()));
    //   }  { 
    //     return Math.floor(this.dwellingUnits + this.additionalLowUnitsEarned);
    //   }
    // },
    zoningDistrictPlaceholder() {
      return this.$t('message.zoningDistrict');
    },
    affordabilityLevelPlaceholder() {
      return this.$t('message.affordabilityLevel');
    },
    springGardenSPlaceholder() {
      return this.$t('message.springGardenS');
    },
    lotAreaSqftPlaceholder() {
      return this.$t('message.lotAreaSqft');
    },
    buildingHeightPlaceholder() {
      return this.$t('message.buildingHeight');
    },
    totalUnitsPlaceholder() {
      return this.$t('message.totalUnits');
    },
    translatedOptions() {
      return this.calculatorOptions.affordabilityLevel.map(option => this.$t(`message.affordability.${option}`));
    },
    translatedOverlays() {
      return this.calculatorOptions.overlays.map(option => this.$t(`message.overlay.${option}`));
    },
  },
  watch: {
    overlays(newOverlays) {
      if (!newOverlays.includes(this.$i18n.t('message.overlay.fithDistrict'))) {
        this.springGardenS = ""; // Reset the value when the overlay is unchecked
      }
    },
  },
  methods: {
    unchecked: function () {
      if (this.overlays.includes(this.$i18n.t('message.overlay.greenRoof'))) {
        this.earthDisturbance = null;
      }
    },
    // Reset is used only for numeric calculations
    reset: function () {
      //this.earthDisturbance = null;
      //this.lotAreaSqFeet = null;
      //this.buildingHeight = null;
      //this.baseFloorArea = null;
      this.springGardenS = null;
      //this.totalFarUnits = null;
    },
    changeLanguage() {
      this.$i18n.locale = this.selectedLanguage;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.columns,
 .column {
  text-align: "columns is-justify-content-space-between";
 }
.content div {
  margin-bottom: 0%;
}
.address-label {
  padding-left: 5px;
}
</style>
